module.exports = __webpack_public_path__ + "static/mobile-header-image-528d5044f00345dc4f6ebb96f64ca308.png";